import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RcDialogWrapperComponent } from '../rc-dialog-wrapper/rc-dialog-wrapper.component';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-signal-popin-send',
  templateUrl: './signal-popin-send.component.html',
  styleUrls: ['./signal-popin-send.component.scss'],
  imports: [RcDialogWrapperComponent, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SignalPopinSendComponent {
  constructor(private dialogRef: MatDialogRef<SignalPopinSendComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
